'use client';

import { useRef } from 'react';
import { css } from '@onbeam/business-styled-system/css';
import { motion, useInView } from 'motion/react';
import { MissionTextRowProps } from './MissionTextRow.types';

export const MissionTextRow = ({
  index,
  words,
  isInitiallyInView,
}: MissionTextRowProps) => {
  const ref = useRef<HTMLSpanElement>(null);
  const isInView = useInView(ref, { amount: 'all', once: true });

  return (
    <motion.span
      ref={ref}
      className={css({ display: 'inline-block' })}
      initial={{ opacity: 0, y: 20, filter: 'blur(3px)' }}
      animate={
        isInView || isInitiallyInView
          ? { opacity: 1, y: 0, filter: 'blur(0)' }
          : { opacity: 0, y: 20, filter: 'blur(3px)' }
      }
      transition={{
        ease: 'easeOut',
        delay: isInitiallyInView ? 0.8 + index * 0.15 : 0,
        duration: 0.5,
      }}
    >
      {words.join(' ')}
    </motion.span>
  );
};
